import apiClient from "./axiosConfig";
const url = '/job-postings'

// Job Posting Functions
const createJobPosting = (data) => {
  return apiClient.post('/job-postings/add/', data);
};

const getActiveJobPostings = () => {
  return apiClient.get('/job-postings/active/list/');
};

const getMyJobPostings = (params = {}) => {
  return apiClient.get(`/recruiter/job-postings/list/`, {params});
};

const getJobPostingById = (id) => {
  return apiClient.get(`/job-postings/${id}/`);
};

const updateJobPosting = (id, data) => {
  return apiClient.patch(`/job-postings/update/${id}/`, data);
};

const deleteJobPosting = (id) => {
  return apiClient.delete(`/job-postings/delete/${id}/`);
};

const getRecommendedJobs = async() => await apiClient.get('/jobs/matching/')

const trackJobView = async (id) => await apiClient.post(`/job-postings/${id}/track-view/`)
const getJobViewStats = async (id) => await apiClient.get(`/job-postings/${id}/views/stats/`)
const getJobPostingChoices = async() => await apiClient.get(`${url}/choices/`)

export default {
    createJobPosting,
  getActiveJobPostings,
  getMyJobPostings,
  getJobPostingById,
  updateJobPosting,
  deleteJobPosting,
  getRecommendedJobs,
  trackJobView,
  getJobViewStats,
  getJobPostingChoices
}